module.exports = __webpack_public_path__ + "static/media/summer-bum-text-en.262e2093.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/summer-bum/summer-bum-text-en.svg
// module id = 2471
// module chunks = 7